import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import * as util from '../utils/util';

/**
 * 로그인이 필요한 라우트를 감싸는 가드.
 *
 * 화면 안에서 useEffect 로 navigate 하지 않고 라우트 단계에서 막는 이유:
 * 그렇게 하면 리다이렉트 전에 화면이 한 번 렌더되어, 디지털트윈처럼 진입과 동시에
 * 13MB 모델을 받기 시작하는 화면에서는 비로그인 사용자에게도 그 다운로드가 걸린다.
 * 여기서 막으면 자식 컴포넌트가 아예 마운트되지 않는다.
 *
 * 판정 기준은 이 프로젝트의 다른 화면들과 같다 — localStorage.userCusID 존재 여부
 * (MoreList·Care·Check 등이 모두 이 값을 쓴다).
 *
 * replace 를 쓰는 이유: 히스토리에 남기면 로그인 화면에서 뒤로가기 했을 때
 * 다시 이 라우트로 들어와 또 튕기는 왕복이 생긴다.
 */
const RequireLogin = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const isLogin = util.strNull(window.localStorage.userCusID) !== '';

  if (!isLogin) {
    // from 은 로그인 후 원래 가려던 곳으로 되돌리고 싶을 때 쓸 수 있다.
    // (현재 Login 화면은 이 값을 읽지 않고 홈으로 보낸다)
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <>{children}</>;
};

export default RequireLogin;
